<template>
  <div>
    <PopupConfirmDateChange v-if="showPopupConfirmDateChange" @success="changeDate" @cancel="cancelChangeDate" />
    <div class="content-devx no-padding-bottom">
      <f7-block class="no-padding">
        <DxForm
          id="form"
          :col-count="1"
          :caption="$t('title_register_plantation')"
        >
          <DxGroupItem :col-count="3">
            <DxSimpleItem
              :data-field="$t('registerPlantation.plantationName')"
              name="name"
              :editor-options="{
                value: plantationName,
                showClearButton: true,
                onValueChanged: onChangeName,
              }"
            >
              <DxRequiredRule message="" />
            </DxSimpleItem>
            <DxSimpleItem
              name="cultive_type"
              :data-field="$t('registerPlantation.cultive_type')"
              editor-type="dxSelectBox"
              :editor-options="{
                items: cropTypes,
                value: cropTypeSelected,
                onValueChanged: onChangeCultiveType,
              }"
            >
              <DxRequiredRule message="" />
            </DxSimpleItem>
            <DxSimpleItem
              name="protected"
              :data-field="$t('registerPlantation.protected')"
              editor-type="dxSelectBox"
              :editor-options="{
                items: protectionTypes,
                value: protectionTypeSelected,
                onValueChanged: onChangeProtectionType,
              }"
              :isRequired="true"
            />
            <DxSimpleItem
              name="manejo"
              :data-field="$t('registerPlantation.manejo')"
              editor-type="dxSelectBox"
              :editor-options="{
                items: managementTypes,
                value: managementTypeSelected,
                onValueChanged: onChangeManagement,
              }"
              :isRequired="true"
            />
            <DxSimpleItem
              :data-field="$t('registerPlantation.init_date')"
              name="init_date"
              editor-type="dxDateBox"
              :editor-options="{
                onValueChanged: onChangeInitDate,
                value: initDateCampania,
                displayFormat: 'dd/MM/yyyy',
                invalidDateMessage: $t('dates_isInvalid'),
                disabledDates: disabledDates,
                inputAttr:inputAttr,
                pickerType: 'calendar',
              }"
            >
              <DxRequiredRule message="" />
            </DxSimpleItem>
            <DxSimpleItem
              name="end-date"
              :data-field="$t('registerPlantation.end_date')"
              editor-type="dxDateBox"
              :editor-options="{
                onValueChanged: onChangeEndDate,
                value: endDateCampania,
                displayFormat: 'dd/MM/yyyy',
                invalidDateMessage: $t('dates_isInvalid'),
                disabledDates: disabledDates,
                inputAttr:inputAttr,
                pickerType: 'calendar',
              }"
            >
              <DxRequiredRule message="" />
            </DxSimpleItem>
          </DxGroupItem>
        </DxForm>
      </f7-block>
    </div>
    <div v-if="cropTypeSelected === 'HORTÍCOLA'">
      <RegisterHorticola
        :species-availables="speciesAvailables"
      />
    </div>
    <div v-if="cropTypeSelected === 'HERBÁCEO'">
      <RegisterHebacea
        :species-availables="speciesAvailables "
      />
    </div>
    <div v-if="cropTypeSelected === 'LEÑOSO'">
      <RegisterLenioso
        :species-availables="speciesAvailables"
      />
    </div>
    <DxPopUPRegisterParcelSectorByPlantation
      :parcels="parcels"
      :sectors="sectors"
    />
  </div>
</template>

<script>
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxRequiredRule,
} from 'devextreme-vue/form';
import moment from 'moment';
import { mapState, mapActions } from 'vuex';
import RegisterHorticola from '../registerHorticola/index.vue';
import RegisterHebacea from '../registerHerbaceas/index.vue';
import RegisterLenioso from '../registerLeñoso/index.vue';
import DxPopUPRegisterParcelSectorByPlantation from '../popUpSelectParcelSector/index.vue';
import PopupConfirmDateChange from '../popupConfirmDateChange/index.vue';

export default {
  name: 'RegisterPlantationStep2',
  components: {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    RegisterHorticola,
    RegisterHebacea,
    RegisterLenioso,
    DxPopUPRegisterParcelSectorByPlantation,
    DxRequiredRule,
    PopupConfirmDateChange
  },
  props: {
    cropTypes: { type: Array, default: () => [] },
    managementTypes: { type: Array, default: () => [] },
    protectionTypes: { type: Array, default: () => [] },
  },
  data() {
    return {
      inputAttr: { inputmode: 'none' },
      dateBoxChanged: null,
      showPopupConfirmDateChange: false
    };
  },
  computed: {
    ...mapState('RegisterPlantation', ['actualPlantation', 'parcels', 'sectors', 'isEdit', 'cropTypeSelected', 'speciesAvailables',
      'initDate', 'endDate', 'managementTypeSelected', 'protectionTypeSelected', 'plantationName']),
    ...mapState('Campania', ['actualCampaign']),
    initDateCampania() {
      if (this.initDate !== '') {
        return moment(this.initDate, 'YYYY-MM-DD');
      }

      return moment(this.actualCampaign.init_date, 'YYYY-MM-DD');
    },
    endDateCampania() {
      if (this.endDate !== '') {
        return moment(this.endDate, 'YYYY-MM-DD');
      }

      return moment(this.actualCampaign.end_date, 'YYYY-MM-DD');
    },
  },
  beforeMount() {
    if (this.isEdit) {
      this.setPlantationName(this.actualPlantation.name);
      this.setInitDate(this.actualPlantation.init_date);
      this.setEndDate(this.actualPlantation.end_date);
      this.setManagementType(this.actualPlantation.management);
      this.setProtectionType(this.actualPlantation.protection);
      this.setCultiveType(this.actualPlantation.crop_type);
    } else {
      setTimeout(() => {
        this.setPlantationName("Cultivo-Variedad");
      }, 100)
    }
  },
  methods: {
    disabledDates(args) {
      const actualDate = moment(args.date, 'YYYY-MM-DD');
      const initDate = moment(this.actualCampaign.init_date, 'YYYY-MM-DD');
      const endDate = moment(this.actualCampaign.end_date, 'YYYY-MM-DD');

      if (args.view === 'month') {
        return !actualDate.isBetween(initDate, endDate, 'days', '[]');
      }

      if (args.view === 'year') {
        return !actualDate.isBetween(initDate, endDate, 'months', '[]');
      }

      if (args.view === 'decade') {
        return !actualDate.isBetween(initDate, endDate, 'years', '[]');
      }

      if (args.view === 'century') {
        const exactYear = parseInt(actualDate.year() / 10) * 10;
        const initDateIsBetween = initDate.year() >= exactYear && initDate.year() <= exactYear + 9;
        const endDateIsBetween = endDate.year() >= exactYear && endDate.year() <= exactYear + 9;

        return !(initDateIsBetween || endDateIsBetween);
      }

      return false;
    },
    onChangeName(e) {
      this.setPlantationName(e.value);
    },
    onChangeInitDate(e) {
      if (!this.isEdit) {
        this.setInitDate(moment(e.value).format('YYYY-MM-DD'));
        return;
      }

      if (this.initDateCampania.isSame(moment(e.value, 'YYYY-MM-DD'))) return;

      this.showPopupConfirmDateChange = true;
      this.dateBoxChanged = { name: 'init_date', e };
    },
    onChangeEndDate(e) {
      if (!this.isEdit) {
        this.setEndDate(moment(e.value).format('YYYY-MM-DD'));
        return;
      }

      if (this.endDateCampania.isSame(moment(e.value, 'YYYY-MM-DD'))) return;

      this.showPopupConfirmDateChange = true;
      this.dateBoxChanged = { name: 'end_date', e };
    },
    changeDate() {
      if (this.dateBoxChanged.name === 'init_date') {
        this.setInitDate(moment(this.dateBoxChanged.e.value).format('YYYY-MM-DD'));
      }

      if (this.dateBoxChanged.name === 'end_date') {
        this.setEndDate(moment(this.dateBoxChanged.e.value).format('YYYY-MM-DD'));
      }

      this.showPopupConfirmDateChange = false;
      this.dateBoxChanged = null;
    },
    cancelChangeDate() {
      this.showPopupConfirmDateChange = false;
      this.dateBoxChanged = null;
    },
    onChangeManagement(e) {
      this.setManagementType(e.value);
    },
    onChangeProtectionType(e) {
      this.setProtectionType(e.value);
    },
    async onChangeCultiveType(e) {
      this.setCultiveType(e.value);
      // this.resetSpecieSelectedAndVarietySelected(); TODO: EN LA EDICION SE RESETEA DESPUES DE DARLE VALOR AL FORMULARIO DINAMICO POR LO QUE SE QUEDA VACIO
      try {
        if (e.value !== '') {
          await this.getSelectBoxSpecies(e.value);
        }
      } catch (error) {
        const message = this.$helpers.getFilteredErrorMessage(error);
        if (message.includes('default_') && !message.includes('404')) {
          this.$f7.dialog.alert(message.split('_').pop());
        } else if (!message.includes('404')) {
          this.$f7.dialog.alert(this.$t(message));
        }
      }
    },
    ...mapActions('RegisterPlantation', ['setPlantationName', 'setProtectionType', 'setManagementType',
      'setInitDate', 'setEndDate', 'setCultiveType', 'getSelectBoxSpecies', 'resetSpecieSelectedAndVarietySelected',
      'initStore']),
  },
};
</script>
